import { Component, OnInit } from '@angular/core';
import { DatepickerOptions } from 'ng2-datepicker';
import * as moment from 'moment';

/**
 * create new partner ID services
 */
import { GetTitleService } from "../../../services/contacts/getTitle/get-title.service"
import { GetCountryStateCityService } from "../../../services/contacts/getCountryStateCity/get-country-state-city.service"
import { PinCodeToGetDetailsService } from "../../../services/contacts/pinCodeToGetDetails/pin-code-to-get-details.service";
import { AddDonateService } from "../../../services/donation/addDonate/add-donate.service";


declare var $: any

@Component({
  selector: 'app-create-new-partner-id',
  templateUrl: './create-new-partner-id.component.html',
  styleUrls: ['./create-new-partner-id.component.less']
})
export class CreateNewPartnerIDComponent implements OnInit {

  options: DatepickerOptions = {
    minYear: 1970,
    maxYear: 2030,
    displayFormat: 'MMM - DD - YYYY',
    barTitleFormat: 'MMM - DD - YYYY',
    dayNamesFormat: '',
    firstCalendarDay: 0, // 0 - Sunday, 1 - Monday
    // locale: frLocale,
    // minDate: new Date(Date.now()), // Minimal selectable date
    maxDate: new Date(Date.now()),  // Maximal selectable date
    barTitleIfEmpty: 'Click to select a date',
    placeholder: 'Click to select a date', // HTML input placeholder attribute (default: '')
    addClass: 'form-control', // Optional, value to pass on to [ngClass] on the input field
    addStyle: {}, // Optional, value to pass to [ngStyle] on the input field
    fieldId: 'my-date-picker', // ID to assign to the input field. Defaults to datepicker-<counter>
    useEmptyBarTitle: false, // Defaults to true. If set to false then barTitleIfEmpty will be disregarded and a date will always be shown 
  };

  /** 
   * create partner ID variables
   */
  public allTitle: any
  public allCSC: any
  public tempState: any
  public allState: any
  public allCity: any
  public allDistrict: any
  public province: Boolean = false
  public marital = {
    married: false
  }

  /**
 * no value in selection box
 */
  public noCountryAvailable: Boolean = true
  public noStateAvailable: Boolean = true
  public noCityAvailable: Boolean = true
  public noCityAvailableCancelButton: Boolean = true
  public noDistrictAvailable: Boolean = true



  public ifSelectedCountryIndia: Boolean
  public mobileNoValidation: Number = 20
  public mobileNoValidationMin: Number = 10

  /**
 * Validation variables
 */
  public invalidPin: Boolean = false
  public ifForeign: Boolean = true

  /** 
  * Loader variables
  */
  public skeleton: Boolean = true
  public pinCodeLoader: Boolean = false


  /**
 * Pin Code to Populate Auto Data
 */
  public pintoPopulate = {
    city: "", state: "", state_id: "", district: "", address3: ""
  }

  /**
   * main variables
   */
  public address1: any = ''
  public address2: any = ''
  public address3: any = ''

  constructor(
    private GetTitleService: GetTitleService,
    private GetCountryStateCityService: GetCountryStateCityService,
    private PinCodeToGetDetailsService: PinCodeToGetDetailsService,
    private AddDonateService: AddDonateService
  ) { }

  async ngOnInit() {
    await this.getTitle()

    this.allCSC = await this.getAllCSC()
    console.log(this.allCSC)
    this.allCSC.push({ name: "None Of This" })

    setTimeout(function () {
      $(`.title`).selectpicker('refresh');
      $(`.language`).selectpicker('refresh');
      $(`.eduction`).selectpicker('refresh');
      $(`.country`).selectpicker('refresh');
      $(`.state`).selectpicker('refresh');
      $("[data-id='State']").prop('disabled', true);
      $(`.city`).selectpicker('refresh');
      $("[data-id='City']").prop('disabled', true);
      $(`.district`).selectpicker('refresh');
      $("[data-id='District']").prop('disabled', true);
    }, 100)
  }

  async createNewPartnerID(val) {
    console.log(val)

    let data = {
      "full_name": val.fullName,
      "title_id": val.title,
      "primary_mobile_no": val.mobileNumber,
      "email_id": val.email,
      "address_line1": val.address1,
      "address_line2": val.address2,
      "address_line3": val.address3,
      "postal_code": val.pinCode,
      "country_id": this.tempState[0].id,
      "state_id": this.pintoPopulate.state_id,
      "state_name": val.state == '' ? this.pintoPopulate.state : val.state,
      "country_name": val.country,
      "district": val.district,
      "city": val.city,
      "dob": moment(val.dob).format("YYYY-MM-DD"),
      "sex": val.gender == 1 ? 'Male' : 'female',
      "martial_status": val.maritalStatus == 1 ? 'Single' : val.maritalStatus == 2 ? 'Married' : 'Widowed',
      "education_id": null,
      "language_id": null,
      "occupation": null,
      "wed_date": val.anniversary == undefined ? null : moment(val.anniversary).format("YYYY-MM-DD"),
      "alter_phone_no": null,
      "land_line_no": null
    }
    console.log(data)
    let result = await this.AddDonateService.donate(data)
    console.log(result)
  }

  async getTitle() {
    let result = await this.GetTitleService.getAllTitle()
    this.allTitle = result.data
  }

  async getAllCSC() {
    return await this.GetCountryStateCityService.getAll()
  }

  async getSelectedCountry(val) {
    if (val == "None Of This") {
      this.noCountryAvailable = false
      this.noStateAvailable = false
      this.noCityAvailable = false
      this.ifForeign = true
      this.mobileNoValidation = 20
    } else {
      this.noStateAvailable = true
      this.noCityAvailable = true
      let state = this.allCSC.filter(country => country.name == val)
      this.tempState = state
      this.allState = Object.keys(state[0].states)
      this.allState.push("None Of This")
      setTimeout(function () {
        $(`.state`).selectpicker('refresh');
        $("[data-id='State']").prop('disabled', false);
      }, 100)

      if (val == 'India') {
        this.mobileNoValidation = 10
        this.ifForeign = false
        this.province = false
        $("#mobileNumber").val("");

      } else {
        this.mobileNoValidation = 20
        // this.=this.tempState[0].phone_code.includes("+") == true ? this.tempState[0].phone_code:"+"+this.tempState[0].phone_code
        $("#mobileNumber").val(this.tempState[0].phone_code.includes("+") == true ? this.tempState[0].phone_code : "+" + this.tempState[0].phone_code);
        this.province = true
      }
    }
  }


  async pinCodeToGetDetails(value) {
    if (!this.ifForeign) {
      let checkValue = /\d{6}/
      this.invalidPin = false
      if (checkValue.test(value)) {
        this.pinCodeLoader = true
        let result = await this.PinCodeToGetDetailsService.getPinDetails(value)

        if (result.status == 404) {
          this.pinCodeLoader = false
          this.invalidPin = true
        } else {
          this.pinCodeLoader = false
          let selectedPin = result.data
          console.log(selectedPin)
          this.pintoPopulate.state = selectedPin[0].STATE_NAME
          this.pintoPopulate.state_id = selectedPin[0].STATE_ID
          this.pintoPopulate.district = selectedPin[0].DISTRICT_NAME

          this.getSelectedState(this.pintoPopulate.state)
          //           $("#address3").val(function() {
          //     return this.value + ','POST_OFFICE;
          // });
          // if (selectedPin.length != 1) {
          this.allState = []
          this.allDistrict = []
          // this.allCity = []
          selectedPin.forEach(element => {
            this.allState.push(element.STATE_NAME)
            this.allDistrict.push(element.DISTRICT_NAME)
          });
          this.allState.push("None Of This")
          this.allDistrict.push("None Of This")

          setTimeout(function () {
            $(`.state`).selectpicker('refresh');
            $(`.city`).selectpicker('refresh');
            $(`.district`).selectpicker('refresh');
            $("[data-id='City']").prop('disabled', false);
            $("[data-id='District']").prop('disabled', false);
          }, 100)
        }
        // }
      }
    }

  }


  async getSelectedDistrict(val) {
    if (val == "None Of This") {
      this.noDistrictAvailable = false
    } else {
      this.allDistrict.forEach(element => {
        // if(this.address3.includes(element.split(',')[1]) != true){
        //   this.address3 = this.address3 == ""? val.split(',')[1]:this.address3 +" "+val.split(',')[1]
        // }else{
        // this.address3 =  this.address3.replace(","+element.split(',')[1], "");

        if ($("#address3").val().includes(',')) {
          $("#address3").val($("#address3").val().replace("," + element.split(',')[1], ""))
        } else {
          $("#address3").val($("#address3").val().replace(element.split(',')[1], ""))
        }
        // this.address3 =  this.address3.replace(","+element.split(',')[1], "");
        //   this.address3 =this.address3 +" "+val.split(',')[1]
        // }
      });
      // this.address3 = this.address3 == ""? val.split(',')[1]:this.address3.trim() +" "+","+val.split(',')[1]
      $("#address3").val($("#address3").val() == "" ? val.split(',')[1] : $("#address3").val().trim() + " " + "," + val.split(',')[1])
    }
  }

  async getSelectedState(val) {
    if (val == "None Of This") {
      this.noStateAvailable = false
      this.noCityAvailable = false
      this.noCityAvailableCancelButton = true
    } else {
      this.noCityAvailable = true
      this.noCityAvailableCancelButton = false
      this.allCity = this.tempState[0].states[val]
      this.allCity.push("None Of This")
      setTimeout(function () {
        $(`.city`).selectpicker('refresh');
        $("[data-id='City']").prop('disabled', false);
      }, 100)
    }
  }

  async onMaritalStatus(ele, val) {
    if (val == 2) {
      this.marital.married = true
    } else {
      this.marital.married = false
    }

  }

  async getSelectedCity(val) {
    if (val == "None Of This") {
      this.noCityAvailable = false
    }
    // this.allPin = this.allPinDistrict.filter(pin => pin.City.match(val))
    // setTimeout(function () {
    //   $(`.pinCode`).selectpicker('refresh');
    //   $("[data-id='PinCode']").prop('disabled', false);
    // }, 100)
  }

  backToSelect(val) {
    switch (val) {
      case 1:
        this.noCountryAvailable = true
        var root = this
        setTimeout(function () {
          $(`.country`).selectpicker('refresh');
        }, 100)
        break;
      case 2:
        this.noStateAvailable = true
        setTimeout(function () {
          $(`.state`).selectpicker('refresh');
        }, 100)
        break;
      case 3:
        this.noCityAvailable = true
        setTimeout(function () {
          $(`.city`).selectpicker('refresh');
        }, 100)
      case 4:
        this.noDistrictAvailable = true
        setTimeout(function () {
          $(`.district`).selectpicker('refresh');
        }, 100)
        break;
    }
  }

  // formEmailValidation(elementValue) {
  //   var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  //   console.log(emailPattern.test(elementValue.toString()))
  //   // if (emailPattern.test(elementValue)) {
  //   //   $("#email").removeClass("is-invalid")
  //   // } else {
  //   //   if ($("#email").hasClass("is-invalid")) {
  //   //     $("#email").removeClass("is-invalid")
  //   //   } else {
  //   //     $("#email").addClass("is-invalid")
  //   //   }
  //   // }
  // }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

}
